export default __webpack_public_path__ + "static/media/Groupe 74.b752d596.png";